export default __webpack_public_path__ + "static/media/avalanche.234db155.svg";